























































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import dialogComp from '@/components/dialog/index.vue';
import { Button } from 'mint-ui';

@Component<VBANNER>({
  components: {
    dialogComp,
    'mt-button': Button,
  },
})
export default class VBANNER extends Vue {
  public tipType: number = 0; /* 0是已参与过活动，1是未中奖 */
  public tipError: string = '';
  public voteList: any = [];
  public showResult: boolean = false;
  public img: string = '';
  public data: any = {
    title: '',
    link: '',
    desc: '',
    span: '',
    price: '',
  };
  public show() {
    (this.$refs.dialog as any).show();
    let timer = setTimeout(() => {
      clearTimeout(timer);
      this.showResult = true;
    }, 500);
  }
  public close() {
    this.showResult = false;
    (this.$refs.dialog as any).close();
  }
  public getMaxW(item: any) {
    let total = 0;
    this.voteList.forEach((vote: any) => {
      total += vote.num;
    });
    return (item.num / total) * 100;
  }
  public goUrl() {
    location.href =
      'https://event.qunar.com/qm/qunargiftnew/index.htm?activityNo=tongyongh5&bdsource=tongyong';
  }
  public callback() {}
  public goLottery() {
    this.callback();
    this.close();
  }
}
